import * as React from "react";
import type { SVGProps } from "react";
const SvgPlacardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="placard_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m446.507 743.85-3.84-18.645 311.168 149.718c84.394 40.576 184.832-18.134 184.832-110.422v-555.69c0-92.288-100.438-151.04-184.832-110.422L373.973 281.173H213.12c-70.187 0-127.787 54.827-127.787 123.35v164.266c0 48.214 28.587 89.728 69.974 110.038l43.221 166.442c14.379 55.126 65.621 93.398 124.032 93.398h12.245c84.395 0 146.432-77.995 122.88-157.355l-11.093-37.419zm-165.718 81.238-34.56-132.907h102.955l14.507 69.632a40.49 40.49 0 0 0 .81 3.286l11.606 39.04c7.594 25.6-12.288 52.053-41.387 52.053h-12.16a42.624 42.624 0 0 1-41.728-31.104zm121.942-211.072a43.05 43.05 0 0 0-18.774-4.267H213.12c-24.107 0-42.965-18.688-42.965-40.96V404.523c0-22.272 18.858-40.96 42.965-40.96h170.752c6.528 0 12.97-1.451 18.816-4.267l388.779-187.008c29.141-14.08 62.293 6.656 62.293 36.523V764.5c0 29.867-33.152 50.56-62.293 36.566L402.73 613.973z"
    />
  </svg>
);
export default SvgPlacardIcon;
